<script setup lang="ts">
import AiBadgePill from './AiBadgePill.vue';
import type { IssueDetailDto } from '@/composables/useIssue';

interface Props {
  issue: IssueDetailDto;
}
defineProps<Props>();
</script>

<template>
  <div
    v-if="issue.aiSummaryText"
    class="bg-surface border border-teal-200 rounded-lg p-4 border-l-4 border-l-teal-500"
    data-testid="ai-summary-detail-card"
  >
    <!-- Teal AI eyebrow per CLAUDE.md non-negotiable -->
    <div class="flex items-center gap-2 mb-2">
      <AiBadgePill label="AI SUMMARY" />
      <span
        v-if="issue.aiSummaryConfidence !== null && issue.aiSummaryConfidence !== undefined"
        class="text-caption text-teal-600 font-mono tabular-nums"
      >
        {{ issue.aiSummaryConfidence }}% confidence
      </span>
      <time
        v-if="issue.aiSummaryGeneratedAt"
        :datetime="issue.aiSummaryGeneratedAt"
        class="text-caption text-muted font-mono tabular-nums ml-auto"
      >
        Generated {{ issue.aiSummaryGeneratedAt.split('T')[0] }}
      </time>
    </div>
    <p class="text-body text-fg">{{ issue.aiSummaryText }}</p>
  </div>
</template>
